import { lazyRetry } from "../../helpers/lazyRetry";

const InvoicesTransfer_L = lazyRetry(() => import("./InvoicesTransfer"));

export default InvoicesTransfer_L;
